import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import { ClearButton } from "./styles";

const OuterContainer = styled.div`
  position: fixed;
  top: 50px;
  padding: 4px;
  z-index: 3;
  width: calc(100% - 80px);
  left: 33px;
  border: 3px solid #e04778;
  border-radius: 20px;
  background-color: #fff;

  @media only screen and (min-width: 975px) {
    top: 140px;
    width: 600px;
    left: calc(50% - 300px);
  }
`;

const Container = styled.div`
  background-color: #f2a7bf;
  border-radius: 16px;
  color: #fff;
  padding: 20px;
  width: calc(100% - 40px);

  @media only screen and (min-width: 975px) {
    padding: 40px;
    width: calc(100% - 80px);
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (min-width: 975px) {
    justify-content: end;
  }
`;

const CloseButtonContainer = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  right: 40px;
  border-radius: 50px;
  height: 27px;
  width: 27px;
  cursor: pointer;

  &:hover {
    background-color: rgb(255, 216, 229);

    & div {
      color: #e04778;
    }
  }
`;

const CloseButton = styled.div`
  color: #fff;
  font-size: 26px;
  align-self: start;
  margin-top: -2.5px;
  margin-left: 6px;
`;

const Heading = styled.h1`
  font-size: 32px;
  text-align: center;
  color: #fff;
  margin-top: 0;
  margin-bottom: 12px;
`;

const InnerContainer = styled.div`
  background-color: rgb(255, 216, 229);
  margin: 0 auto;
  border-radius: 12px;
  border: none;
  padding: 20px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 26px;
  color: #666;
  max-height: 320px;
  overflow-y: scroll;

  div:not(:last-child) {
    margin-bottom: 24px;
  }

  a {
    color: #e04778;
  }
`;

const SuccessModal = ({
  closeModal,
  moreTransactions,
  transactionHash,
  setTransactionHash,
  setMoreTransactions,
}) => {
  const handleClick = useCallback(
    (event) => {
      event.stopPropagation();
      const shouldClose = ![
        "success-modal",
        "success-modal-container",
        "success-modal-heading",
        "success-modal-inner-container",
        "success-modal-div",
        "success-modal-link",
        "success-modal-div-two",
        "success-modal-btns-container",
      ].includes(event.target.id);
      if (shouldClose) {
        closeModal();
      }
    },
    [closeModal]
  );

  const handleClose = useCallback(() => {
    closeModal();
    setTransactionHash("");
    setMoreTransactions(false);
  }, [setTransactionHash, setMoreTransactions, closeModal]);

  useEffect(() => {
    const body = document.querySelector("body");
    body.addEventListener("click", handleClick);
    return () => {
      body.removeEventListener("click", handleClick);
    };
  }, [handleClick]);

  return (
    <OuterContainer id="success-modal">
      <Container id="success-modal-container">
        <CloseButtonContainer onClick={closeModal}>
          <CloseButton>×</CloseButton>
        </CloseButtonContainer>
        <Heading id="success-modal-heading">Success!</Heading>
        <InnerContainer id="success-modal-inner-container">
          <div id="success-modal-div">
            Your{" "}
            {transactionHash ? (
              <a
                id="success-modal-link"
                href={`https://etherscan.io/tx/${transactionHash}`}
                target="_blank"
                rel="noreferrer noopener"
              >
                transaction
              </a>
            ) : (
              "transaction"
            )}{" "}
            has processed!
          </div>
          {moreTransactions && (
            <div id="success-modal-div-two">
              It looks like you have another transaction to approve, check your
              wallet.
            </div>
          )}
        </InnerContainer>
        <ButtonsContainer id="success-modal-btns-container">
          <ClearButton onClick={handleClose} noMargin>
            OK
          </ClearButton>
        </ButtonsContainer>
      </Container>
    </OuterContainer>
  );
};

export default SuccessModal;
